import { Div, RefBool, Text } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Panel extends Div
{
    constructor(header: appendable, body: appendable[])
    {
        super("panel");

        const isOpen = new RefBool(true).Storable("panel:is-open:" + header);

        this.Append(
            new Div("panel-header-container")
                .OnClick(() => isOpen.Toggle())
                .Append(
                    new Div("panel-header").Append(header),
                    body.length > 0 && new Text(isOpen, v => v ? "▼" : "▲").CursorPointer()
                    // .OnClick(() => isOpen.Toggle())
                ),
            new Div("panel-body-container")
                .Visible(isOpen, "block")
                .Append(...body)
        );
    }
}
